export const NUMBER_OF_PAYMENT = [
  {
    id: 1,
    text: '一括',
  },
]
